import { render, staticRenderFns } from "./OsParticipantGlobalOverview.vue?vue&type=template&id=206e29a5&scoped=true"
import script from "./OsParticipantGlobalOverview.vue?vue&type=script&lang=ts"
export * from "./OsParticipantGlobalOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206e29a5",
  null
  
)

export default component.exports